import { render, staticRenderFns } from "./WxLink.vue?vue&type=template&id=37936154&scoped=true"
import script from "./WxLink.vue?vue&type=script&lang=js"
export * from "./WxLink.vue?vue&type=script&lang=js"
import style0 from "./WxLink.vue?vue&type=style&index=0&id=37936154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37936154",
  null
  
)

export default component.exports